<div class="flex flex-col gap-6 w-full max-w-lg">
  <p class="text-xl">BC Sync</p>

  <!-- Sync BC to DB -->
  <div class="sync-card">
    <div class="flex flex-col gap-1 mb-4">
      <p class="text-base font-semibold text-gray-800">Sync BC to DB</p>
      <p class="text-sm text-gray-500">Fetches the latest data from Business Central and writes it to the database.</p>
    </div>

    <button
      mat-flat-button
      color="primary"
      [disabled]="bcSyncStatus() === 'loading'"
      (click)="syncBcToDb()"
    >
      @if (bcSyncStatus() === 'loading') {
        <mat-spinner diameter="18" class="inline-spinner"></mat-spinner>
        Syncing...
      } @else {
        <mat-icon>sync</mat-icon>
        Sync BC to DB
      }
    </button>

    @if (bcSyncStatus() === 'success') {
      <p class="status-message success"><mat-icon class="status-icon">check_circle</mat-icon>{{ bcSyncMessage() }}</p>
    } @else if (bcSyncStatus() === 'error') {
      <p class="status-message error"><mat-icon class="status-icon">error</mat-icon>{{ bcSyncMessage() }}</p>
    }
  </div>

  <!-- Sync DB to DevOps -->
  <div class="sync-card">
    <div class="flex flex-col gap-1 mb-4">
      <p class="text-base font-semibold text-gray-800">Sync DB to DevOps</p>
      <p class="text-sm text-gray-500">Pushes the current database state to Azure DevOps.</p>
    </div>

    <button
      mat-flat-button
      color="primary"
      [disabled]="devopsSyncStatus() === 'loading'"
      (click)="syncDbToDevOps()"
    >
      @if (devopsSyncStatus() === 'loading') {
        <mat-spinner diameter="18" class="inline-spinner"></mat-spinner>
        Syncing...
      } @else {
        <mat-icon>cloud_upload</mat-icon>
        Sync DB to DevOps
      }
    </button>

    @if (devopsSyncStatus() === 'success') {
      <p class="status-message success"><mat-icon class="status-icon">check_circle</mat-icon>{{ devopsSyncMessage() }}</p>
    } @else if (devopsSyncStatus() === 'error') {
      <p class="status-message error"><mat-icon class="status-icon">error</mat-icon>{{ devopsSyncMessage() }}</p>
    }
  </div>
</div>
